export enum ROLES {
  CLIENT_ADMIN = 'ROLE_CSA_ADMIN',
  USER = 'USER'
}
